import type { LocaleDisplay } from '@icetus/contracts';

/**
 * 语言入口的四档。
 *
 * 文案按客户关心的**结果**写，不按实现写：「平铺」「下拉」是他在前台看到的
 * 样子，「自动」必须说清判断标准，否则它就是个说不清结果的选项；
 * 「不显示」要说清代偿手段（访客仍能用网址前缀进别的语言），
 * 不然客户会以为关了之后就再也切不过去了。
 *
 * 放在 lib 而不是页面里：这一排按钮现在归「页头页脚」，而「站点信息」的
 * 语言卡还要留一句指路。两边各抄一份选项表，早晚有一处会少一档。
 */
export const LOCALE_DISPLAY_OPTIONS: Array<{
  value: LocaleDisplay;
  label: string;
  hint: string;
}> = [
  { value: 'auto', label: '自动', hint: '两种语言平铺，三种以上收成下拉' },
  { value: 'inline', label: '平铺', hint: '语言名全部横排，点一下就切' },
  { value: 'menu', label: '下拉', hint: '只露当前语言，点开再选' },
  {
    value: 'hidden',
    label: '不显示',
    hint: '前台不放语言入口（页头、页脚都没有）。访客仍能通过搜索结果或 /es 这样的网址前缀进入其它语言',
  },
];

/**
 * 这一档下，语言入口要不要收成下拉。
 *
 * 与前台 `LocaleLinks` 的判定必须一致：两处各写一份三元表达式，
 * 改档位时只会改到正在看的那一处，另一处继续按老规则画。
 * `count` 是已开通语言数（含默认语言）。
 */
export function localeMenuFor(display: LocaleDisplay, count: number): boolean {
  if (display === 'menu') return true;
  if (display === 'hidden') return false;
  if (display === 'inline') return false;
  return count > 2;
}

/** 前台到底有没有语言入口 */
export function localeVisible(display: LocaleDisplay): boolean {
  return display !== 'hidden';
}
